<template>
    <img :src="thumbnail" alt="" v-if="thumbnail">
</template>

<script>
    import Axios from 'axios'

    export default {
        created() {
            this.getThumbnail()
        },

        data() {
            return {
                thumbnail: null
            }
        },

        methods: {
            getThumbnail() {
                if (this.photoId) {
                    Axios.get('/umbraco/api/SearchApi/Thumbnail', { params: { format: this.format, photoId: this.photoId } })
                        .then((response) => {
                            if (response.status == 200) {
                                this.thumbnail = response.data
                            }
                        })
                }
            }
        },

        props: {
            format: {
                default: 'jpg',
                type: String
            },
            photoId: {
                default: 0,
                type: Number
            }
        },

        watch: {
            photoId: function () {
                this.getThumbnail()
            }
        }
    }
</script>